import { form } from "./form.js"; // Предполагается, что form.js существует и нужен для grecaptchaCallback
import { displayMessage } from "../alert/messageFunc.js";
import { translate } from "../helpers/translations.js";
import { RECAPTCHA_SITE_KEY } from "../common.js";

// Для старой логики grecaptchaCallback, если она используется где-то еще
export function grecaptchaCallback(response) {
    //console.log('grecaptcha callback', response);
    let $recaptchas = $('textarea.g-recaptcha-response');
    let $filledRecaptchas = $recaptchas.filter((i, el) => el.value);
    $filledRecaptchas.each((i, el) => form(el));
}

// Глобальные переменные reCAPTCHA
let recaptchaWidgetId = null;
let isRecaptchaApiLoaded = false;
let currentChallengeCallbacks = {}; // Для хранения колбэков текущей проверки
let isRecaptchaWidgetInitialized = false;

const recaptchaModalElement = document.getElementById('recaptchaModal');
const recaptchaContainerInModal = document.getElementById('recaptcha-container-in-modal');
const modalErrorMessageBlock = document.getElementById('modal-error-message__block');
const modalErrorMessageElement = document.getElementById('modal-error-message');

// 1. Callback, вызываемый при загрузке API reCAPTCHA
function onRecaptchaApiLoad() {
    console.log('reCAPTCHA API loaded.');
    isRecaptchaApiLoaded = true;
    
    // Инициализируем виджет, если DOM уже загружен
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        initRecaptchaWidget();
    }
}
window.onRecaptchaApiLoad = onRecaptchaApiLoad; // Сделать доступным глобально для API reCAPTCHA

// Функция для инициализации виджета reCAPTCHA
function initRecaptchaWidget() {
    if (!isRecaptchaApiLoaded || isRecaptchaWidgetInitialized || !recaptchaContainerInModal) {
        return;
    }

    try {
        recaptchaWidgetId = grecaptcha.render(recaptchaContainerInModal, {
            'sitekey': RECAPTCHA_SITE_KEY,
            'callback': internalOnRecaptchaSuccess,
            'expired-callback': internalOnRecaptchaExpired,
            'error-callback': internalOnRecaptchaError,
            'size': 'normal',
            'theme' : 'dark'
        });
        isRecaptchaWidgetInitialized = true;
        console.log('reCAPTCHA widget initialized with ID:', recaptchaWidgetId);
    } catch (error) {
        console.error("Error pre-rendering reCAPTCHA widget:", error);
        // Не показываем ошибку пользователю на этом этапе
    }
}

// Внутренняя функция для закрытия модального окна
function internalCloseRecaptchaModal(isCancelled = false) {
    if (recaptchaModalElement) {
        recaptchaModalElement.classList.remove('open');
        recaptchaModalElement.classList.remove('show'); // Убедимся, что убираем 'show'
    }
    if (recaptchaWidgetId !== null) {
        try {
            grecaptcha.reset(recaptchaWidgetId);
        } catch (e) {
            console.warn("Error resetting reCAPTCHA widget:", e);
        }
    }
    if (isCancelled && typeof currentChallengeCallbacks.onCancel === 'function') {
        currentChallengeCallbacks.onCancel();
    }
    currentChallengeCallbacks = {}; // Сбросить колбэки
}

// 2. Функция для инициации проверки reCAPTCHA
export function showRecaptchaChallenge(callbacks) {
    if (!isRecaptchaApiLoaded) {
        displayMessage(translate('Recaptcha system is still loading. Please wait a few seconds and try again.'), 'error', translate('Error'));
        if (typeof callbacks.onError === 'function') {
            callbacks.onError('API not loaded');
        }
        return;
    }
    if (!recaptchaModalElement || !recaptchaContainerInModal || !modalErrorMessageElement || !modalErrorMessageBlock) {
        console.error('Recaptcha modal elements not found');
        if (typeof callbacks.onError === 'function') {
            callbacks.onError('Modal elements not found');
        }
        return;
    }

    currentChallengeCallbacks = callbacks; // Сохраняем колбэки

    modalErrorMessageElement.textContent = '';
    modalErrorMessageBlock.style.display = 'none';
    recaptchaModalElement.classList.add('open');
    recaptchaModalElement.classList.add('show');

    // Проверяем, инициализирован ли виджет
    if (!isRecaptchaWidgetInitialized) {
        try {
            initRecaptchaWidget();
        } catch (error) {
            console.error("Error rendering reCAPTCHA:", error);
            modalErrorMessageElement.textContent = translate('Failed to load verification. Please refresh the page and try again.');
            modalErrorMessageBlock.style.display = '';
            if (typeof currentChallengeCallbacks.onError === 'function') {
                currentChallengeCallbacks.onError(error.message || 'Render error');
            }
        }
    } else {
        // Если виджет уже был инициализирован, просто сбросим его
        grecaptcha.reset(recaptchaWidgetId);
    }
}

// 3. Внутренние Callback-функции reCAPTCHA
function internalOnRecaptchaSuccess(token) {
    console.log('reCAPTCHA token:', token);
    modalErrorMessageElement.textContent = '';
    modalErrorMessageBlock.style.display = 'none';

    if (typeof currentChallengeCallbacks.onSuccess === 'function') {
        currentChallengeCallbacks.onSuccess(token);
    } else {
        console.warn("onSuccess callback for reCAPTCHA challenge is not defined.");
        // Если нет обработчика, лучше закрыть, чтобы не зависало
        internalCloseRecaptchaModal(true);
    }
}

function internalOnRecaptchaExpired() {
    console.warn('Recaptcha token expired.');
    modalErrorMessageElement.textContent = translate('Verification timed out. Please complete it again.');
    modalErrorMessageBlock.style.display = '';
    if (typeof currentChallengeCallbacks.onExpired === 'function') {
        currentChallengeCallbacks.onExpired();
    }
    // Виджет сам предложит пройти проверку заново, не закрываем модалку
}

function internalOnRecaptchaError(error) {
    console.error('Recaptcha error:', error);
    modalErrorMessageElement.textContent = translate('Verification error. Please refresh the page or try again.');
    modalErrorMessageBlock.style.display = '';
    if (typeof currentChallengeCallbacks.onError === 'function') {
        currentChallengeCallbacks.onError(error || 'Unknown reCAPTCHA error');
    }
}

// 4. Экспортируемая функция для закрытия модального окна извне (например, после успешного логина)
export function closeRecaptchaModal() {
    internalCloseRecaptchaModal(false); // false - не считать отменой от пользователя
}

// 5. Инициализация обработчиков закрытия для самого модального окна reCAPTCHA
document.addEventListener('DOMContentLoaded', () => {
    if (recaptchaModalElement) {
        const closeButton = recaptchaModalElement.querySelector('.block__item-link.js-close.close-icon');
        if (closeButton) {
            closeButton.addEventListener('click', () => internalCloseRecaptchaModal(true));
        }

        recaptchaModalElement.addEventListener('click', (event) => {
            if (event.target === recaptchaModalElement || event.target.classList.contains('item-close')) {
                internalCloseRecaptchaModal(true);
            }
        });

        const modalWrapper = recaptchaModalElement.querySelector('.modal-wrapper.modal-content');
        if (modalWrapper) {
            modalWrapper.addEventListener('click', (event) => {
                if (event.target === modalWrapper) {
                    internalCloseRecaptchaModal(true);
                }
            });
        }
        
        // Инициализируем reCAPTCHA виджет, если API уже загружен
        if (isRecaptchaApiLoaded) {
            initRecaptchaWidget();
        }
    }
});